<div class="row">
    <div class="col-lg-12">
        <div class="card card-outline-success">
            <div class="card-header">
                <h4 class="m-b-0 text-white">Ayuda e Información</h4>
            </div>
            <div class="card-body">
              <a target="_blank" href="{{API.sinCriterio + 'ticketAyuda.ppsx'}}"><button class="form-control">¿Como crear un Ticket? (Power Point)</button></a>
            </div>
       </div>
    </div>
</div>


// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_components/ayuda/ayuda.component.html